import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Crown, LogOut } from "lucide-react";

const navItems = [
  { to: "/dashboard", label: "Dashboard" },
  { to: "/analyze", label: "Analyze" },
  { to: "/occasion", label: "Ceremony" },
  { to: "/gallery", label: "Gallery" },
  { to: "/favorites", label: "Favorites" },
  { to: "/pricing", label: "Premium" },
];

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function signIn() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="crown-glass sticky top-0 z-40" data-testid="navbar">
      <div className="crown-container flex items-center justify-between py-5">
        <Link to="/" className="flex items-center gap-2 group" data-testid="navbar-logo">
          <Crown className="text-gold" strokeWidth={1.5} size={22} />
          <span className="font-serif text-2xl tracking-tight text-bone group-hover:text-gold transition-colors">Style Me Perfectly!</span>
        </Link>

        {user && (
          <nav className="hidden md:flex items-center gap-8" data-testid="navbar-links">
            {navItems.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `font-overline transition-colors ${isActive ? "text-gold" : "text-ash hover:text-bone"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
        )}

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <button
                data-testid="navbar-profile-btn"
                onClick={() => navigate("/profile")}
                className="hidden sm:flex items-center gap-3 group"
              >
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-8 h-8 object-cover" />
                ) : (
                  <div className="w-8 h-8 bg-secondary flex items-center justify-center text-xs font-mono">
                    {user.name?.[0]?.toUpperCase() || "U"}
                  </div>
                )}
                <div className="text-left">
                  <p className="text-xs text-ash group-hover:text-bone transition-colors">{user.name?.split(" ")[0]}</p>
                  {user.is_premium && <p className="font-overline text-[0.6rem] text-gold">Premium</p>}
                </div>
              </button>
              <button
                data-testid="navbar-logout-btn"
                onClick={logout}
                className="text-ash hover:text-gold transition-colors"
                aria-label="Log out"
              >
                <LogOut strokeWidth={1.5} size={18} />
              </button>
            </>
          ) : (
            <button onClick={signIn} className="crown-btn-primary" data-testid="navbar-signin-btn">
              Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
